var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "m9.516 7.315-.009.02-3.25 7.791C6.052 15.656 5.558 16 5 16a1.345 1.345 0 0 1-1.257-.875l-.016-.038-3.23-7.74q-.006-.015-.014-.032A5.2 5.2 0 0 1 0 5.117C0 2.295 2.243 0 5 0s5 2.295 5 5.117c0 .77-.163 1.508-.484 2.198M5 2.587c-1.363 0-2.472 1.135-2.472 2.53S3.638 7.647 5 7.647c1.363 0 2.472-1.136 2.472-2.53 0-1.395-1.109-2.53-2.472-2.53"
  })));
};
export default SvgPin;